<template>
  <div class="work">
    <HeaderComponent/>
    <div class="slogan">
        <img src="https://cyvideo.i-oranges.com/home/12.jpg" alt="">
    </div>
    <ProjectComponent/>
    <ServiceComponent/>
    <FooterComponent/>
    <BackToTop :visibility-height="500" :bottom="50" :right="50"/>
  </div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent'
import FooterComponent from '../components/FooterComponent'
import ProjectComponent from '../components/ProjectComponent'
import ServiceComponent from '../components/ServiceComponent'


export default {
  name: "work",
  components: {
    HeaderComponent,
    FooterComponent,
    ProjectComponent,
    ServiceComponent,

  }
}
</script>

<style scoped>
.work {
  width: 100%;
}
.slogan{
  width: 100%;
}
.slogan img{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/work.vue